import AppHeaderFooter, { AppHeaderFooterProps } from './AppHeaderFooter';

export default AppHeaderFooter;
export type { AppHeaderFooterProps };
